import {ExclusiveDealsSelectorUI} from '../ui/ExclusiveDealsSelectorUI';
import {BulkDealsSelectorUI} from '../ui/BulkDealsSelectorUI';
import {GiftDealsSelectorUI} from '../ui/GiftDealsSelectorUI';
import {useEffect, useState} from 'react';

export const DealSelector = ({ productDeals, selection, onSelectionChange }) => {
  const [exclusiveDeals, setExclusiveDeals] = useState([]);
  const [bulkDeals, setBulkDeals] = useState([]);
  const [giftDeals, setGiftDeals] = useState([]);

  const [hasDealsToChose, setHasDealsToChose] = useState(false);

  useEffect(() => {
    if (!productDeals) {
      return;
    }

    setExclusiveDeals(productDeals.OFERTASEXCLUSIVAS);
    setBulkDeals(productDeals.LOTES);
    setGiftDeals(productDeals.PROMOCIONES);
  }, [productDeals]);

  useEffect(() => {
    setHasDealsToChose(!exclusiveDeals.find(it => it.cantidad === 1));
  }, [exclusiveDeals, selection]);

  return (
    <div className="fw-lighter">
      <ExclusiveDealsSelectorUI selection={selection} exclusiveDeals={exclusiveDeals} onDealSelection={onSelectionChange} />
      <GiftDealsSelectorUI selection={selection} giftDeals={giftDeals} onDealSelection={onSelectionChange} />
      <BulkDealsSelectorUI selection={selection} bulkDeals={bulkDeals} onDealSelection={onSelectionChange} />
      {
        hasDealsToChose && (
          <div className="px-2 d-flex flex-row gap-3 justify-content-start align-items-center">
            <input type="radio"
                   name="noDeal"
                   checked={!selection}
                   onChange={(event) => {
                     event.target.checked && onSelectionChange(null);
                   }} />
            <strong>No quiero ninguna promoción</strong>
          </div>
        )
      }
    </div>
  );
};